import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { Canal } from "@/lib/envio-colaborador-api";
import { Moldura, Titulo } from "./moldura";

export function Recibo({
  canal,
  protocolo,
  onNovoEnvio,
}: {
  canal: Canal;
  protocolo: string;
  onNovoEnvio: () => void;
}) {
  return (
    <Moldura
      canal={canal}
      passo={null}
      acao={
        <>
          <Button
            variant="outline"
            className="h-14 rounded-xl text-base"
            onClick={onNovoEnvio}
          >
            Enviar outro atestado
          </Button>
          <p className="text-center text-[13px] text-slate-600">
            Dúvidas? Fale com o RH da sua unidade.
          </p>
        </>
      }
    >
      <span
        aria-hidden="true"
        className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100 text-green-700"
      >
        <Check className="h-8 w-8" />
      </span>
      <Titulo className="mt-2 text-[28px]">Atestado recebido</Titulo>
      <p className="text-[15px] text-slate-600">
        O RH da {canal.nome} vai analisar seu atestado. Guarde o número do
        protocolo:
      </p>
      <div className="mt-2 flex flex-col gap-1 rounded-2xl bg-slate-100 p-4">
        <span className="text-xs font-semibold tracking-wider text-slate-600 uppercase">
          Protocolo
        </span>
        <span className="font-mono text-lg font-semibold">{protocolo}</span>
      </div>
    </Moldura>
  );
}
